import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import DeveloperPrivateRoute from './DeveloperPrivateRoute';
import PartnerLogin from '../pages/PartnerLogin';
import DeveloperLayout from '../pages/developer/DeveloperLayout';
import DeveloperHome from '../pages/developer/DeveloperHome';
import DeveloperKeys from '../pages/developer/DeveloperKeys';
import DeveloperWebhooks from '../pages/developer/DeveloperWebhooks';
import DeveloperUsage from '../pages/developer/DeveloperUsage';
import DeveloperDocs from '../pages/developer/DeveloperDocs';
import DeveloperWidgets from '../pages/developer/DeveloperWidgets';
import DeveloperSandbox from '../pages/developer/DeveloperSandbox';
import DeveloperChangelog from '../pages/developer/DeveloperChangelog';
import CatalogEmbed from '../pages/developer/CatalogEmbed';
import ApiReferenceIndex, { ApiEndpointDoc } from '../pages/developer/ApiReference';

/**
 * Routes for developer.dejavunomad.com (absolute paths).
 * Pass nested when mounted under /developer/* on the main app.
 */
const DeveloperHostRoutes = ({ nested = false } = {}) => {
  const loginPath = nested ? 'login' : '/login';
  const embedPath = nested ? 'embed/catalog/:token' : '/embed/catalog/:token';
  const catchAllTo = nested ? '/developer' : '/';

  const protectedLayout = (
    <DeveloperPrivateRoute>
      <DeveloperLayout />
    </DeveloperPrivateRoute>
  );

  const docsRoutes = (
    <>
      <Route index element={<DeveloperHome />} />
      <Route path="keys" element={<DeveloperKeys />} />
      <Route path="webhooks" element={<DeveloperWebhooks />} />
      <Route path="usage" element={<DeveloperUsage />} />
      <Route path="docs" element={<DeveloperDocs />} />
      <Route path="widgets" element={<DeveloperWidgets />} />
      <Route path="sandbox" element={<DeveloperSandbox />} />
      <Route path="docs/api" element={<ApiReferenceIndex />} />
      <Route path="docs/api/:sectionId/:endpointId" element={<ApiEndpointDoc />} />
      <Route path="changelog" element={<DeveloperChangelog />} />
    </>
  );

  return (
    <Routes>
      <Route path={loginPath} element={<PartnerLogin />} />
      <Route path={embedPath} element={<CatalogEmbed />} />
      {nested ? (
        <Route element={protectedLayout}>{docsRoutes}</Route>
      ) : (
        <Route path="/" element={protectedLayout}>{docsRoutes}</Route>
      )}
      <Route path="*" element={<Navigate to={catchAllTo} replace />} />
    </Routes>
  );
};

export default DeveloperHostRoutes;
